export default __webpack_public_path__ + "static/media/05.7f720474.png";